import { useDemoState } from "@/state/demoState";

export const useSelection = () => {
    const selectedItem = useDemoState((state) => state.selectedItem);

    return {
        selectedItem,
    };
};
